import React, { FC, ReactNode } from 'react';

import { Button, IButtonProps } from '@src/atoms/Button';
import { Description, IDescriptionProps } from '@src/atoms/Description';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import { Divider } from '@src/atoms/Divider';
import { Grid } from '@src/atoms/Grid';
import { IDefaultComponentProps } from '@src/models/props';
import { TGridAdaptive } from '@src/models/adaptive';
import { classnames } from '@src/utils/classnames';

import styled from './Card.module.scss';

interface IElement extends IDescriptionProps {}
interface IButton extends IButtonProps {
  /*
    Содержимое кнопки
   */
  content: string | ReactNode;
}

interface IProps extends IDefaultComponentProps {
  /*
    Заголовок карточки
   */
  title: string;

  /*
    Элементы с информацией
   */
  elements: IElement[];

  /*
    Кнопки
   */
  buttons?: IButton[];

  /*
    Количество колонок
   */
  columns?: TGridAdaptive;
}

export const Card: FC<IProps> = ({ title, elements, buttons, columns = 3 }) => {
  const containerClass = classnames(styled.container, { [styled.containerWithButtons]: !!buttons?.length });
  const columnsCount = buttons?.length ? 2 : columns;

  return (
    <Box column>
      <Box marginBottom={4}>
        <Text id={title} size={'caption'} color={'basicGreySemiDark'} weight={'semiBold'}>
          {title}
        </Text>
      </Box>
      <Box marginBottom={24}>
        <Divider view={'basicGreySemiDark'} />
      </Box>
      <Grid className={containerClass}>
        <Grid columns={columnsCount} className={styled.elementsWrapper}>
          {elements.map((element, index) => (
            <Box key={index}>
              <Description {...element} />
            </Box>
          ))}
        </Grid>
        {buttons?.length && (
          <Box marginLeft={16} gap={8} alignItems={'start'} justifyContent={'end'} wrap>
            {buttons.map((button, index) => (
              <Button key={index} {...button}>
                {button.content}
              </Button>
            ))}
          </Box>
        )}
      </Grid>
    </Box>
  );
};
